import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        ignoreId: Number
    },
    data() {
        return {

            /** Map (Object) of loaded entries, mapped by their ID
             * @type {Record.<number, Object>} */
            entriesMap: {},

            /** Map (Object) of rendered (shown across all pages in pagination) entries, mapped by their ID
             * @type {Record.<number, Object>} */
            renderedEntriesMap: {},

            /** Map (Object) of field value arrays containing all values of loaded entries' props, mapped by their prop name.
             * Assignment happens in loadData of entriesLoaderMixin.js.
             * For example; fieldValuesMap.name is an array with length of Object.keys(this.entriesMap).length, containing
             * objects with value of the 'name' prop of each entry, accompanied by the entry's id. This way entries can be retrieved
             * from this.entriesMap when a particular value is searched for in the 'name' prop
             * @type {Record.<string, {id: number, value: Object}[]>} */
            fieldValuesMap: {}
        };
    },
    computed: {
        entries() {
            const entriesWithoutIgnoredId = {...this.entriesMap};
            delete entriesWithoutIgnoredId[this.ignoreId];
            return Object.values(entriesWithoutIgnoredId);
        }
    }
});
